import Icon from '@/components/ui/AppIcon';

interface Tip {
  category: string;
  title: string;
  description: string;
  icon: string;
}

interface TravelTipProps {
  tip: Tip;
}

const TravelTip = ({ tip }: TravelTipProps) => {
  return (
    <div
      style={{ backgroundColor: '#0F2234', border: '1px solid rgba(111,211,224,0.12)' }}
      className="rounded-xl p-5 hover:border-cyan-400/30 transition-all duration-300 shadow-md hover:shadow-xl transform hover:-translate-y-1"
    >
      <div className="flex items-start space-x-4">
        <div className="flex-shrink-0">
          <div style={{ backgroundColor: 'rgba(111,211,224,0.1)' }} className="w-10 h-10 rounded-full flex items-center justify-center">
            <Icon name={tip.icon as any} size={20} style={{ color: '#6FD3E0' }} />
          </div>
        </div>
        <div className="flex-1">
          <div className="flex items-center space-x-2 mb-2">
            <span style={{ backgroundColor: 'rgba(111,211,224,0.1)', color: '#6FD3E0', border: '1px solid rgba(111,211,224,0.2)' }} className="px-2 py-1 text-xs rounded font-semibold">
              {tip.category}
            </span>
          </div>
          <h4 style={{ color: '#EAF4F8' }} className="text-base font-headline font-semibold mb-2">
            {tip.title}
          </h4>
          <p style={{ color: '#C8DDE6' }} className="text-sm leading-relaxed">
            {tip.description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TravelTip;